// extracted by mini-css-extract-plugin
export default {"toolbar":"CustomToolbar_toolbar__nNClJ","year":"CustomToolbar_year__PbIBq","date":"CustomToolbar_date__i913t","day":"CustomToolbar_day__B5suh"};